import * as React from 'react';
import Svg, {ClipPath, Defs, G, Path, Rect} from 'react-native-svg';
type LogoProps = {
  size: number;
  style?: Record<string, unknown>;
}; // tslint:disable

export default class EmptyBalance extends React.Component<LogoProps> {
  getWidth() {
    if (this.props.style && this.props.style['size']['width']) {
      return this.props.style['size']['width'];
    } else {
      return 95;
    }
  }

  getHeight() {
    if (this.props.style && this.props.style['size']['height']) {
      return this.props.style['size']['height'];
    } else {
      return 86;
    }
  }

  render() {
    return (
      <>
        <Svg
          width={this.getWidth()}
          height={this.getHeight()}
          viewBox="0 0 95 86"
          fill="none"
        >
          <G clip-path="url(#clip0_13817_1378)">
            <Path
              d="M84.1277 16.2206C87.0127 16.2206 89.3434 18.5929 89.3434 21.5294V26.8382C83.5899 26.8382 78.9121 22.0769 78.9121 16.2206H84.1277ZM21.5395 16.2206H73.6964C73.6964 25.0133 80.7049 32.147 89.3434 32.147V53.3823C80.7049 53.3823 73.6964 60.5161 73.6964 69.3088H21.5395C21.5395 60.5161 14.5309 53.3823 5.89244 53.3823V32.147C14.5309 32.147 21.5395 25.0133 21.5395 16.2206ZM5.89244 58.6912C11.646 58.6912 16.3238 63.4525 16.3238 69.3088H11.1081C8.2232 69.3088 5.89244 66.9364 5.89244 64V58.6912ZM78.9121 69.3088C78.9121 63.4525 83.5899 58.6912 89.3434 58.6912V64C89.3434 66.9364 87.0127 69.3088 84.1277 69.3088H78.9121ZM16.3238 16.2206C16.3238 22.0769 11.646 26.8382 5.89244 26.8382V21.5294C5.89244 18.5929 8.2232 16.2206 11.1081 16.2206H16.3238ZM11.1081 10.9117C5.35458 10.9117 0.676758 15.6731 0.676758 21.5294V64C0.676758 69.8563 5.35458 74.6176 11.1081 74.6176H84.1277C89.8813 74.6176 94.5591 69.8563 94.5591 64V21.5294C94.5591 15.6731 89.8813 10.9117 84.1277 10.9117H11.1081ZM42.4022 34.8014C42.4022 36.2614 43.5758 37.4559 45.0101 37.4559V48.0735H43.7062C42.2719 48.0735 41.0983 49.268 41.0983 50.7279C41.0983 52.1878 42.2719 53.3823 43.7062 53.3823H47.6179H51.5297C52.964 53.3823 54.1375 52.1878 54.1375 50.7279C54.1375 49.268 52.964 48.0735 51.5297 48.0735H50.2258V34.8014C50.2258 33.3415 49.0522 32.147 47.6179 32.147H45.0101C43.5758 32.147 42.4022 33.3415 42.4022 34.8014ZM31.9709 42.7647C31.9709 38.5407 33.6194 34.4898 36.5538 31.503C39.4882 28.5162 43.4681 26.8382 47.6179 26.8382C51.7678 26.8382 55.7477 28.5162 58.6821 31.503C61.6165 34.4898 63.265 38.5407 63.265 42.7647C63.265 46.9886 61.6165 51.0396 58.6821 54.0264C55.7477 57.0132 51.7678 58.6912 47.6179 58.6912C43.4681 58.6912 39.4882 57.0132 36.5538 54.0264C33.6194 51.0396 31.9709 46.9886 31.9709 42.7647ZM68.4807 42.7647C68.4807 37.1327 66.2826 31.7315 62.3701 27.7491C58.4576 23.7667 53.1511 21.5294 47.6179 21.5294C42.0848 21.5294 36.7783 23.7667 32.8657 27.7491C28.9532 31.7315 26.7552 37.1327 26.7552 42.7647C26.7552 48.3966 28.9532 53.7979 32.8657 57.7803C36.7783 61.7627 42.0848 64 47.6179 64C53.1511 64 58.4576 61.7627 62.3701 57.7803C66.2826 53.7979 68.4807 48.3966 68.4807 42.7647Z"
              fill="#707070"
            />
          </G>
          <Defs>
            <ClipPath id="clip0_13817_1378">
              <Rect
                width="93.8824"
                height="84.9412"
                fill="white"
                transform="translate(0.676758 0.294067)"
              />
            </ClipPath>
          </Defs>
        </Svg>
      </>
    );
  }
}
